import * as React from "react";
import { SVGProps } from "react";
export const SpeakerFillIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <mask
            id="mask0_11068_94190"
            style={{
                maskType: "alpha",
            }}
            maskUnits="userSpaceOnUse"
            x={0}
            y={0}
            width={20}
            height={20}
        >
            <rect width={20} height={20} fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_11068_94190)">
            <path
                d="M15.8751 10.875C15.639 10.875 15.4341 10.7882 15.2605 10.6146C15.0869 10.441 15.0001 10.2362 15.0001 10C15.0001 9.76393 15.0869 9.55907 15.2605 9.38546C15.4341 9.21185 15.639 9.12504 15.8751 9.12504H17.4584C17.6945 9.12504 17.8994 9.21185 18.073 9.38546C18.2466 9.55907 18.3334 9.76393 18.3334 10C18.3334 10.2362 18.2466 10.441 18.073 10.6146C17.8994 10.7882 17.6945 10.875 17.4584 10.875H15.8751ZM15.2917 16.125L14.0209 15.1875C13.8265 15.0348 13.7119 14.8403 13.6772 14.6042C13.6424 14.3681 13.7015 14.1528 13.8542 13.9584C14.007 13.7639 14.2015 13.6493 14.4376 13.6146C14.6737 13.5799 14.889 13.6389 15.0834 13.7917L16.3542 14.7292C16.5487 14.882 16.6633 15.0764 16.698 15.3125C16.7327 15.5487 16.6737 15.7639 16.5209 15.9584C16.3681 16.1528 16.1737 16.2674 15.9376 16.3021C15.7015 16.3368 15.4862 16.2778 15.2917 16.125ZM15.0834 6.20838C14.889 6.36115 14.6772 6.42018 14.448 6.38546C14.2188 6.35074 14.0279 6.23615 13.8751 6.04171C13.7223 5.84726 13.6633 5.63199 13.698 5.39588C13.7327 5.15976 13.8473 4.96532 14.0417 4.81254L15.3126 3.85421C15.507 3.70143 15.7188 3.6424 15.948 3.67713C16.1772 3.71185 16.3681 3.82643 16.5209 4.02088C16.6737 4.21532 16.7327 4.4306 16.698 4.66671C16.6633 4.90282 16.5487 5.09726 16.3542 5.25004L15.0834 6.20838ZM4.16675 15.8334V12.5H3.41675C2.95841 12.5 2.55216 12.3507 2.198 12.0521C1.84383 11.7535 1.66675 11.375 1.66675 10.9167V9.08338C1.66675 8.62504 1.84383 8.24657 2.198 7.94796C2.55216 7.64935 2.95841 7.50004 3.41675 7.50004H6.66675L9.50008 5.79171C9.79175 5.61115 10.0869 5.60421 10.3855 5.77088C10.6841 5.93754 10.8334 6.19449 10.8334 6.54171V13.4584C10.8334 13.8056 10.6841 14.0625 10.3855 14.2292C10.0869 14.3959 9.79175 14.3889 9.50008 14.2084L6.66675 12.5H5.91675V15.8334H4.16675ZM11.7084 12.7917V7.20838C12.0834 7.54171 12.3855 7.94796 12.6147 8.42713C12.8438 8.90629 12.9584 9.4306 12.9584 10C12.9584 10.5695 12.8438 11.0938 12.6147 11.573C12.3855 12.0521 12.0834 12.4584 11.7084 12.7917Z"
                fill="currentColor"
            />
        </g>
    </svg>
);
SpeakerFillIcon.displayName = "SpeakerFillIcon";
